// Vue
import Vue from "vue";
import i18n from "./i18n";
import App from "./App";
// 核心插件
import d2Admin from "@/plugin/d2admin";
// store
import store from "@/store/index";

// 菜单和路由设置
import router from "./router";
import menuHeader from "@/menu/header";
import menuAside from "@/menu/aside";
import { frameInRoutes } from "@/router/routes";
import D2Crud from "@d2-projects/d2-crud";
// Import Froala Editor
import "froala-editor/js/plugins.pkgd.min.js";
// Import third party plugins
import "froala-editor/js/third_party/embedly.min";
import "froala-editor/js/third_party/font_awesome.min";
import "froala-editor/js/third_party/spell_checker.min";
import "froala-editor/js/third_party/image_tui.min";
import "froala-editor/js/languages/zh_cn";
// Import Froala Editor css files.
import "froala-editor/css/froala_editor.pkgd.min.css";

import util from "@/libs/util.js";
import VueParticles from "vue-particles";
// Import and use Vue Froala lib.
import VueFroala from "vue-froala-wysiwyg";
import VueUeditorWrap from "vue-ueditor-wrap";
import ECharts from "vue-echarts"; // 在 webpack 环境下指向 components/ECharts.vue

// 手动引入 ECharts 各模块来减小打包体积
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/map/js/china.js";

Vue.component("vue-ueditor-wrap", VueUeditorWrap);
Vue.component("v-chart", ECharts);

Vue.use(VueParticles);
Vue.use(VueFroala);

// 核心插件
Vue.use(d2Admin);
Vue.use(D2Crud);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit("d2admin/page/init", frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit("d2admin/menu/headerSet", menuHeader);
    // 设置侧边栏菜单
    this.$store.commit("d2admin/menu/asideSet", menuAside);
    // 初始化菜单搜索功能
    this.$store.commit("d2admin/search/init", menuHeader);
    if(process.env.VUE_APP_THEME){
      this.$store.dispatch('d2admin/theme/set', process.env.VUE_APP_THEME)
    }else{
      this.$store.dispatch('d2admin/theme/set', 'main')
    }
  },
  mounted() {
    // 展示系统信息
    this.$store.commit("d2admin/releases/versionShow");
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch("d2admin/account/load");
    // 获取并记录用户 UA
    this.$store.commit("d2admin/ua/get");
    // 初始化全屏监听
    this.$store.dispatch("d2admin/fullscreen/listen");
  },
  watch: {
    // 检测路由变化切换侧边栏内容
    "$route.matched": {
      handler(matched) {
        // 左侧菜单 只显示当前的
        let userInfo = this.$store.state.d2admin.user.info
        let trueAsideMenu = menuAside
        if (userInfo.role && userInfo.role.user_menu) {
          trueAsideMenu = JSON.parse(userInfo.role.user_menu)
        }
        if (matched.length > 0) {
          const _side = trueAsideMenu.filter(
            menu =>
              menu.path === matched[0].path || menu.path === matched[1].path
          )
          this.$store.commit(
            "d2admin/menu/asideSet",
            _side.length > 0 ? _side[0].children : []
          );
        }
      },
      immediate: true
    }
  }
}).$mount("#app");
